//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { current_use_update, current_use_modifyPwd } from '@/apis/user'
import { Base64 } from 'js-base64'

export default {
    data() {
        //表單校驗
        const rules = {
            loginUsername: [{ required: true, message: '請輸入登錄用戶名！' }],
            realname: [{ required: true, message: '請輸入真實姓名！' }],
            sex: [{ required: true, message: '請選擇性別！' }],
            telphone: [{ required: true, message: '請輸入電話！' }],
        };


        let validateRePassword = (rule, value, callback) => {
            console.log(this.pwdform);
            if ((value || '') === '') {
                callback(new Error('請確認密碼！'));
            } else if (value !== this.pwdform.confirmPwd) {
                callback(new Error("兩次密碼輸入不壹致！"));
            } else {
                callback();
            }
        };

        const pwdrules = {
            originalPwd: [{ required: true, message: '請輸入舊密碼！' }],
            confirmPwd: [{ required: true, message: '請輸入新密碼！' }],
            repassrowd: [{ required: true, validator: validateRePassword }],
        };



        const form = {
            loginUsername: null,
            avatarUrl: null,
            realname: null,
            sex: null,
        };

        const pwdform = {
            originalPwd: null,
            confirmPwd: null,
            repassrowd: null
        };


        return {
            id: '',
            form,
            rules,
            pwdform,
            pwdrules,
            spinning: false,
            fileLoading: false,
            fileList: [],
            previewVisible: false,
            previewImage: null,
            labelCol: { style: { width: '150px', }, },
            wrapperCol: { span: 14, },
        }
    },
    async mounted() {
        await this.onPageLoad();
    },
    methods: {
        async onPageLoad() {
            const item = this.$store.state.user || {};
            const form = { ...this.form };
            form.loginUsername = item.loginUsername;
            form.realname = item.realname;
            form.avatarUrl = item.avatarUrl;
            form.sex = `${item.sex}`;
            this.form = form;
            this.onLoadFile();
        },
        async handleFormValidate(e) {
            e.preventDefault();
            this.$refs.form.validate(async valid => {
                if (valid) {
                    await this.onSubmit();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handlePwdFormValidate(e) {
            e.preventDefault();
            this.$refs.pwdform.validate(async valid => {
                if (valid) {
                    await this.onPwdSubmit();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        async onPwdSubmit() {
            try {
                this.spinning = true;
                const submitForm = {
                    ...this.pwdform,
                };
                submitForm.originalPwd = Base64.encode(submitForm.originalPwd);
                submitForm.repassrowd = Base64.encode(submitForm.repassrowd);
                submitForm.confirmPwd = Base64.encode(submitForm.confirmPwd);
                
                const res = await current_use_modifyPwd(submitForm);
                if (res.code == 0) {
                    this.$message.success('提交成功');
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }

            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.spinning = false;
            }
        },

        async onSubmit() {
            try {
                this.spinning = true;
                const submitForm = {
                    ...this.form,
                };
                const res = await current_use_update(submitForm);
                if (res.code == 0) {
                    this.$message.success('提交成功');
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }

            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.spinning = false;
            }
        },
        async onLoadFile() {
            function getFileName(path) {
                const regex = /([^\/\\]+)$/;
                const match = regex.exec(path);
                if (match) {
                    return match[1];
                } else {
                    return null;
                }
            }
            const url = this.form.avatarUrl;
            if (url) {
                this.fileList = [{
                    uid: '-1',
                    name: getFileName(url),
                    status: 'done',
                    url: url
                }]
            }
        },
        async handleFileChange({ fileList }) {
            console.log('handleFileChange', fileList);
            if (fileList.length > 0) {
                // 過濾掉非圖片文件
                const validFiles = fileList.filter(file =>
                    file.type?.startsWith('image/') ||
                    (file.originFileObj && file.originFileObj.type.startsWith('image/'))
                );
                try {
                    this.fileLoading = true;
                    const formData = new FormData();
                    formData.append('file', validFiles[0].originFileObj);
                    const res = await oss_files('ifBG', formData);
                    if (res.code == 0) {
                        this.form.venueImage = res.data;
                        this.fileList = validFiles;
                    } else {
                        this.$message.error(res.msg);
                    }
                } catch (error) {
                    this.$message.error(error.message);
                } finally {
                    this.fileLoading = false;
                }
            } else {
                this.fileList = fileList;
            }

        },
        async handleFilePreview(file) {
            function getBase64(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = error => reject(error);
                });
            }
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }
            this.previewImage = file.url || file.preview;
            this.previewVisible = true;
        },
        handlePreviewCancel() {
            this.previewVisible = false;
        },
    }
}
